import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../../Checkout/Components/Header/Header";
import Footer from "../../../../components/Footer";
import Loader from "../../../../components/Loader/Loader";
import Breadcrumbs from "../../../../components/Checkout/Breadcrumbs/BreadCrumbs";
import OrderStatus from "./OrderStatus";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";
import MetaTags from "../../../../components/MetaTags";
import useExperienceData from "../../../../hooks/useExperienceData";
import { FindBookingWithPaymentIdResponse, getOrderFromPaymentId } from "../../../../services/experienceOrderService";

const Enjoy = () => {
    const currentStep = 3;
    const [searchParams] = useSearchParams();
    const paymentId = searchParams.get("external_reference")
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [haveTime] = useState(false);
    const [order, setOrder] = useState<FindBookingWithPaymentIdResponse | null>(null);

    // Get order from checkout context
    const { experience, promoter } = useExperienceData();


    useEffect(() => {
        const fetchPromoter = async () => {
            try {
                if (paymentId) {
                    setLoading(true);
                    const order = await getOrderFromPaymentId(paymentId);
                    if (order.booking.status === "created") navigate("/");
                    setOrder(order);

                    setLoading(false);
                    if (process.env.NODE_ENV === "production") {
                        ReactGA.event(
                            'Sale', {
                            category: promoter?.alias ? promoter?.alias : 'Convertion',
                            action: order.booking.status,
                            label: order?.booking?.quotation?.title, // optional,
                        });
                    }
                }



            } catch (e) {
                localStorage.removeItem("tp_order_id")
                navigate("/");
            }
        };
        fetchPromoter();
    }, [navigate, paymentId, promoter?.alias]);




    if (loading || !experience || !promoter || !order) return <Loader />;

    const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <MetaTags
                name={promoter?.fullname || ""}
                icon={promoter?.logoURL || ""}
                url={currentUrl}
                font={experience.font ? experience.font : null}
                primaryColor={experience.colors.primary_color ? experience.colors.primary_color : null}
                secondaryColor={experience.colors.secondary_color ? experience.colors.secondary_color : null}
            />
            <Header promoter={promoter}></Header>
            <div className="enjoy__container">
                <Breadcrumbs currentStep={currentStep} orderStatus={order.booking?.status} noGoBack={true}></Breadcrumbs>
                <div className="main-content">
                    <OrderStatus order={order} haveTime={haveTime}></OrderStatus>
                </div>
            </div>
            <Footer loading={false} promoter={promoter}></Footer>
        </HelmetProvider>
    );
};

export default Enjoy;
